module.exports = __webpack_public_path__ + "static/media/edit.ae49fe70.svg";